<template lang="pug">
  v-main#livestream
    v-container(
      id="cart"
      class="cart-container"
    )
      template(v-if="!cart.length")
        v-card(
          class="cart-card"
        ) 
          v-card-title
            h3.header-title Your Livestream Orders
          v-card-text
            b Your livestream order cart is empty.
      template(v-else)
        v-card(
          class="cart-card"
        ) 
          v-card-title
            h3.header-title Your Livestream Orders
          v-card-subtitle.my-2
            v-icon(
              color="primary"
            ) mdi-cart
            b.ml-1 {{ cart[0].order_id }}
          v-card-subtitle.my-2
            v-icon(
              color="primary"
            ) mdi-store
            b.ml-1 {{ cart[0].merchant_name }}
          v-list(
            class="p-0"
            three-line
            flat
          )
            v-list-item-group
              template(
                v-for="(i, index) in cart"
              )
                v-list-item(
                  :key="index"
                )
                  template(v-slot:default="{ active }")
                    v-list-item-action(
                      class="m-auto"
                    )
                      b X {{ i.item_quantity }}
                    v-list-item-content(
                      class="ml-2"
                    )
                      v-list-item-title
                        b.text-uppercase {{i.item_id}}: 
                        em {{ i.item_name }}
                      v-list-item-subtitle(v-if="i.item_remarks") * {{ i.item_remarks }}
                    v-list-item-action(
                      class="m-auto"
                    )
                      span RM {{ calculatePrice(i) }}
                    v-list-item-action(
                      class="ml-4 m-auto"
                    )
                      v-btn(
                        color="red"
                        small
                        @click="deleteItem(index)"
                      )
                        v-icon mdi-delete
                v-divider(
                  class="m-0"
                  v-if="index < cart.length - 1"
                  :key="'divider'+index"
                )
      .checkout-container
        v-card(
          class="checkout-card flex-grow-1"
        )
          v-card-title
            h3.header-title Confirm your order
          v-card-text
            v-form(
              v-model="valid"
              ref="delivery"
              lazy-validation
            )
              v-text-field(
                v-model="name"
                label="Customer Name"
                :rules="[v => !!v || 'Name is required']"
                required
                append-icon="mdi-pencil"
              )
              v-text-field(
                v-model="email"
                label="Customer E-mail"
                :rules="[v => !!v || 'E-mail is required', v => /.+@.+\..+/.test(v) || 'E-mail must be valid']"
                required
                append-icon="mdi-pencil"
              )
              v-text-field(
                v-model="phoneNo"
                label="Customer Phone Number"
                :rules="[v => !!v || 'Phone Number is required', v => !/^\d+$/.test(v) || 'Phone number must be valid']"
                required
                append-icon="mdi-pencil"
              )
              v-text-field(
                v-model="address"
                label="Customer Address"
                :rules="[v => !!v || 'Address is required']"
                required
                append-icon="mdi-pencil"
              )
          v-card-text
            v-textarea(
              class="mt-4 m-2 pt-4"
              clearable
              clear-icon="mdi-close-circle"
              label="Remarks"
              v-model="remarks"
            )
            v-row(
              class="cart-card-button"
              align="center"
            )
              b.d-flex 
                div Order Total: 
                .mx-2.text-warning.small(
                  v-if="oriPrice != salePrice"
                  class="text-decoration-line-through"
                ) RM {{ oriPrice }}
                div.text-success.ml-4 RM {{ salePrice }}
              b.d-flex 
                div Delivery Fee: 
                div.text-warning.ml-4 RM {{ deliveryFee.toFixed(2) }}
              b.d-flex 
                div Grand Total: 
                div.text-info.ml-4 RM {{ finalPrice }}
            v-row(
              class="cart-card-button"
              align="center"
            )
              v-btn(
                tile
                color="green"
                @click="checkout"
              )
                v-icon(center) mdi-cash
                span Confirm Order
          //- v-card-actions
          //-   v-row(
          //-     class="cart-card-button mt-0"
          //-     align="center"
          //-   )
          //-     v-btn(
          //-       tile
          //-       color="red lighten-1"
          //-       @click="clearCart"
          //-     )
          //-       v-icon(center) mdi-delete
          //-       span Clear Cart
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";

export default {
  data() {
    return {
      valid: false,
      remarks: "",
      name: "",
      email: "",
      phoneNo: "",
      address: "",
      deliveryFee: 10,
      cart: [],
      decrypted: null,
      loaded: false,
      feedback: {
        success: false,
        status: errorTags.request.failed
      }
    };
  },
  watch: {
    cart(val) {
      if (val.length) {
        this.name = val[0].customer_name;
        this.email = val[0].customer_email;
        this.phoneNo = val[0].customer_phoneno;
        this.address = val[0].customer_address;
      }
    }
  },
  computed: {
    oriPrice() {
      return this.cart.reduce((acc, x) => {
        return acc + parseFloat(this.calculateOriPrice(x));
      }, 0);
    },
    salePrice() {
      return this.cart.reduce((acc, x) => {
        return acc + parseFloat(this.calculatePrice(x));
      }, 0);
    },
    finalPrice() {
      return (this.salePrice + this.deliveryFee).toFixed(2);
    },
    merchantConstraints() {
      return this.$store.getters.merchantConstraints;
    }
  },
  mounted() {
    if (this.$route.query.q != undefined) this.getDetails();
    this.$store.commit("layout/setDisplayTitle", "Livestream Order Cart");
    // this.redirectToOrderTypePage();
  },
  methods: {
    deleteItem(i) {
      const swalWithBootstrapButtons = this.$swal.mixin({
        customClass: {
          confirmButton: "btn btn-success",
          cancelButton: "btn btn-danger"
        },
        buttonsStyling: false
      });
      swalWithBootstrapButtons
        .fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, delete it!",
          cancelButtonText: "No, cancel!",
          reverseButtons: true
        })
        .then(result => {
          if (result.isConfirmed) {
            let url = config.livestreamCancelUrl();

            var json = {
              livestream_id: this.decrypted.livestream_id,
              customer_id: this.decrypted.customer_id,
              order_id: this.decrypted.order_id,
              suborder_id: this.cart[i].suborder_id,
              merchant_id: this.decrypted.merchant_id,
              menu_id: this.cart[i].menu_id,
              item_id: this.cart[i].item_id,
              item_oriprice: this.cart[i].item_oriprice,
              item_saleprice: this.cart[i].item_saleprice
            };

            this.loading = true;

            this.$http
              .post(url, json)
              .then(function(response) {
                // Success
                try {
                  if (response) {
                    this.loading = false;

                    if (!this.$helpers.handleResponse(response.body.message))
                      return;

                    this.feedback.success =
                      response.body.data ||
                      this.$helpers.handleResponse(response.body.message)
                        ? true
                        : false;

                    if (this.feedback.success) {
                      this.cart.splice(i, 1);

                      swalWithBootstrapButtons.fire(
                        "Deleted!",
                        "Your item has been deleted.",
                        "success"
                      );
                    } else {
                      this.$swal(
                        this.$t("error.customer_livestream_update"),
                        response.body.message,
                        "error"
                      );
                    }
                  }
                } catch (error) {
                  this.feedback.success = false;
                  this.$swal(
                    this.$t("error.customer_livestream_update"),
                    response.body.message,
                    "error"
                  );
                }
              })
              .catch(response => {
                this.feedback.success = false;
                this.$swal(
                  this.$t("error.customer_livestream_update"),
                  response.body.message,
                  "error"
                );
              });
          } else if (
            /* Read more about handling dismissals below */
            result.dismiss === this.$swal.DismissReason.cancel
          ) {
            swalWithBootstrapButtons.fire(
              "Cancelled",
              "Your item is safe :)",
              "error"
            );
          }
        });
    },
    calculateOriPrice(i) {
      var total = 0;

      //normal item price
      total += parseFloat(i.item_oriprice);

      return (total * i.item_quantity).toFixed(2);
    },
    calculatePrice(i) {
      var total = 0;

      //normal item price
      total +=
        parseFloat(i.item_saleprice) != 0
          ? parseFloat(i.item_saleprice)
          : parseFloat(i.item_oriprice);

      return (total * i.item_quantity).toFixed(2);
    },
    checkout() {
      if (!this.$refs.delivery.validate()) return;

      let url = config.livestreamUpdateUrl();

      var json = {
        order_id: this.decrypted.order_id,
        customer_id: this.decrypted.customer_id,
        customer_name: this.name,
        customer_email: this.email,
        customer_phoneno: this.phoneNo,
        customer_address: this.address
      };

      this.loading = true;

      this.$http
        .post(url, json)
        .then(function(response) {
          // Success
          try {
            if (response) {
              this.loading = false;

              if (!this.$helpers.handleResponse(response.body.message)) return;

              this.feedback.success =
                response.body.data ||
                this.$helpers.handleResponse(response.body.message)
                  ? true
                  : false;

              if (this.feedback.success) {
                this.$store.commit("customer/updateCheckout", {
                  orderId: response.body.data.order_id,
                  suborderId: response.body.data.suborder_id,
                  orderRemarks: this.remarks,
                  orderDesc:
                    "Livestream Order Payment - " + this.cart[0].merchant_name,
                  orderAmount: this.finalPrice
                });
                this.$router.push("/checkout");
              } else {
                this.$swal(
                  this.$t("error.customer_livestream_update"),
                  response.body.message,
                  "error"
                );
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.$swal(
              this.$t("error.customer_livestream_update"),
              response.body.message,
              "error"
            );
          }
        })
        .catch(response => {
          this.feedback.success = false;
          this.$swal(
            this.$t("error.customer_livestream_update"),
            response.body.message,
            "error"
          );
        });
    },
    DecryptData(encrypted) {
      const crypto = require("crypto");
      const ENC_KEY = Buffer.from("anybookappsecretkey", "utf8")
        .toString("hex")
        .slice(0, 32); // set random encryption key
      const IV = "thisisatotalsecret".toString("hex").slice(0, 16);
      let decipher = crypto.createDecipheriv("aes-256-cbc", ENC_KEY, IV);
      let decrypted = decipher.update(encrypted, "base64", "utf8");
      return decrypted + decipher.final("utf8");
    },
    getDetails() {
      let url = config.livestreamDetailsUrl();

      this.decrypted = JSON.parse(
        this.DecryptData(
          decodeURIComponent(this.$route.query.q).replace(/ /g, "+")
        )
      );

      var json = {
        params: this.decrypted
      };

      this.loaded = false;

      this.$http.get(url, json).then(function(response) {
        // Success
        this.loaded = true;
        try {
          if (response) {
            this.loading = false;

            if (!this.$helpers.handleResponse(response.body.message)) return;

            this.feedback.success =
              response.body.data ||
              this.$helpers.handleResponse(response.body.message)
                ? true
                : false;

            if (this.feedback.success == true) {
              this.cart = response.body.data;
            }
          }
        } catch (error) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      });
    }
  }
};
</script>
